import React from 'react';
import "./side.css"

function SideFilter({handleFromSliderChange, 
        handleToSliderChange, 
        minRange, 
        maxRange, 
        startLimit, 
        endLimit, 
        handlePriceRangeClick,
        handleProvinceClick,
        provinceList
    }){

    // Calculate percentage position of slider based on value, min, and max
    const calculatePosition = (value, min, max) => {
        return ((value - min) / (max - min)) * 100;
    };

    // Create the linear-gradient background
    const getSliderBackground = () => {
        const minPercent = calculatePosition(minRange, startLimit, endLimit);
        const maxPercent = calculatePosition(maxRange, startLimit, endLimit);

        return `linear-gradient(to right, rgb(203, 213, 225) 0%, rgb(203, 213, 225) ${minPercent}%, rgb(176, 147, 67) ${minPercent}%, rgb(176, 147, 67) ${maxPercent}%, rgb(203, 213, 225) ${maxPercent}%, rgb(203, 213, 225) 100%)`;
    };

   
  return (
    <div className="side-filter-container">
        <div className="side-filt-inn">
            Filters
            {
                provinceList &&
                provinceList.length > 0 && (
                    <div className="item-line-box">
                        <h4>Provinces</h4>
                        <div className="item-line">
                            {
                                provinceList.map((prov, index) => {
                                    return <div className="check-opt" key={index}>
                                            <button className="searh-prov-check" onClick={() => handleProvinceClick(prov.name)}>                                                 
                                                <div className="lbl-check">{prov.name}</div>
                                            </button>
                                        </div>
                                })
                            }
                        </div>
                    </div>
                )
            }

            
            <div className="item-line-box">
                <h4>Cost</h4>
                <div className="item-line">
                <div className="range_container">
                    <div className="sliders_control">
                                <div 
                                    id="fromSliderTooltip" 
                                    className="slider-tooltip fromslide" 
                                    style={{
                                        left: `calc(${calculatePosition(minRange, startLimit, endLimit)}% - 5px)`, // 15px to adjust center of tooltip
                                    }}>
                                    {minRange}
                                </div>
                                <input id="fromSlider" 
                                    type="range" 
                                    value={minRange} 
                                    min={startLimit} 
                                    max={endLimit} steps="10" 
                                    onChange={handleFromSliderChange}/>

                                <div 
                                    id="toSliderTooltip" 
                                    className="slider-tooltip toslide"
                                    style={{
                                        left: `calc(${calculatePosition(maxRange, startLimit, endLimit)}% - 5px)`,
                                    }}
                                    >{maxRange}</div>
                                <input id="toSlider" type="range" 
                                    value={maxRange} 
                                    min={startLimit} 
                                    max={endLimit} 
                                    steps="10" 
                                    onChange={handleToSliderChange}
                                    style={{
                                        background: getSliderBackground(), // Dynamically set background gradient
                                    }}
                                    />
                            </div>
                            <div id="scale" className="scale" data-steps="startLimit"></div>

                            <button 
                                className={"btn btn-law"}
                                onClick={handlePriceRangeClick}
                                >
                                Go
                            </button>
                     </div>    
                </div>
            </div>
            
        </div>
    </div>
  )
}

export default SideFilter